<button class="d-none" id="alert_model1" (click)="openModal(alert_model)"></button>
<ng-template #alert_model let-c="close" let-d="dismiss">
    <div class="modal-body text-center py-4">
        <p>You have been away for quite some time. <br>
            To continue the session, please refresh.
        </p>
        <button type="button" class="btn btn-primary" (click)="updateSession(); d('Cross click')">Refresh</button>
    </div>
</ng-template>